/**
      *********************************************************
      Description: Handles grid component.
      Required props:  type.
      limitations    : just displays the grid data. on double click on the row changes the route.
      *********************************************************
**/

import { process } from '@progress/kendo-data-query';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Grid, GridColumn, GridColumnMenuFilter } from '@progress/kendo-react-grid';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { useHistory, useLocation, useParams, withRouter } from 'react-router-dom';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { handlecustomCondition } from '../../modules/form/conditions';
import { getOptions, loadreportdata } from '../components/savegridreport';
import { handleActionsToEffects, handleRules } from '../effects/effects';
import { groupByType } from '../helpers/components';
import { CustomColumnMenu } from './customColumnMenu.jsx';
import GridHeader from './kendoheader';
import DefaultSettings from './settings';
import { useDispatch, useSelector } from 'react-redux';
import { getEnvVariable } from '../../../modules/environmentalList';
import { Delete } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { Chip, Divider, Icon } from '@material-ui/core';
const _ = require('lodash');


function handleFieldChange(state, action) {
    const { type, ...otherProps } = action
    if (type === 'sharedValues') {
        const { sharedValues } = otherProps
        const newstate = { ...state, sharedValues: sharedValues }
        return newstate
    }
    if (type === 'updates') {
        let newstate = { ...state }
        const { updates } = otherProps
        const { prop, grid, gridExport, columnProps, value, datastate, layout, validations, required, reducerReduxVals, isexport } = updates
        if (prop) {
            prop.forEach(each => {
                const { name, value, result, hasValue, disabled, ...otherProps } = each;
                if (hasValue) {
                    state = { ...state, fieldValues: { ...state.fieldValues, [name]: value || (disabled ? 'Y' : 'N') }, ...otherProps, reducerReduxVals }
                }
                state = { ...state, ...otherProps }
            })
            newstate = { ...state }
        }

        if (grid || gridExport) {
            let gridVal = grid || gridExport
            gridVal.forEach(each => {
                const { data, value, ...otherProps } = each;
                if (Object.keys(data).length !== 0) {
                    let tempData = []
                    if (data && data.value)
                        tempData = data.value.data
                    else if (data && data.Message) {
                        tempData = [];
                        // if (DefaultSettings.getAlert() != null)
                        //     DefaultSettings.getAlert().show('No Results are Found', 'info');
                    }

                    else tempData = data && (data.data ? data.data : (Array.isArray(data) ? data : []));
                    let convertList = {};
                    let columns = newstate.gridColumns;
                    let duplicateList = {}
                    columns.map(res => {
                        if (res.convert)
                            convertList[res.field] = res.convert;
                        if (res.createDuplicate)
                            duplicateList[res.field] = res.createDuplicate
                    })

                    if (duplicateList && Object.keys(duplicateList).length > 0)
                        tempData.forEach(eachData => {
                            Object.keys(duplicateList).forEach(dl => {
                                if (!eachData[duplicateList[dl]])
                                    eachData[duplicateList[dl]] = eachData[dl]
                            })
                        })
                    let convertListKeys = Object.keys(convertList);
                    convertListKeys && convertListKeys.length > 0 && convertListKeys.forEach(listKeys => {
                        if (data && data.data && data.data.length > 0 || (Array.isArray(data) && data.length > 0)) {
                            tempData.map(list => {
                                if (list[listKeys]) {
                                    //need to change according to case for now date is added
                                    list[listKeys] = moment(list[listKeys]).format(convertList[listKeys])
                                }
                                // if (list.NewValue) {
                                //     list.NewValue = list.NewValueDesc && list.NewValueDesc !== null ? list.NewValueDesc : list.NewValue
                                // }
                                // if (list.OldValue) {
                                //     list.OldValue = list.OldValueDesc && list.OldValueDesc !== null ? list.OldValueDesc : list.OldValue
                                // }
                            })
                        }
                    })
                    if (data) {
                        if (grid) {
                            newstate = {
                                ...newstate, ['data']: tempData, ['total']: data.total ? data.total : (data.value && data.value.total ? data.value.total : tempData.length),
                                isexport: (state.fieldValues.exportaction === 'Y' || state.fieldValues.exportaction == true) ? true : false
                            }
                        }
                        else {
                            newstate = { ...newstate, ['exportdata']: tempData, isexport: (state.fieldValues.exportaction === 'Y' || state.fieldValues.exportaction == true) ? true : false }
                        }
                    }
                }


            })

        }
        if (columnProps) {
            const { value } = columnProps
            newstate = { ...newstate, gridColumns: value }
        }
        if (datastate) {
            newstate = { ...state, dataState: datastate, data: state.data && state.data.data ? process(state.data.data, datastate) : process(state.data, datastate) }
            // return newstate
        }
        if (value) {
            value.forEach(each => {
                const { key, result } = each
                newstate = { ...newstate, fieldValues: { ...newstate.fieldValues, [key]: result } }
            })
            // newstate = { ...newstate } //return newstate = { ...state }
        }
        if (isexport) {
            newstate = { ...state, isexport: false, }
            // return newstate
        }
        return newstate
    }
    return state
}

const defaults = {
    mapActionsToEffects: {}
}

// const DetailComponent = (props) => {
//     const data = props.dataItem.details;

//     if (data) {
//         return (
//             <Grid data={data}>
//                 <GridColumn field="ProductID" title="Product ID" width="120px" />
//                 <GridColumn field="ProductName" title="Product Name" />
//                 <GridColumn field="UnitPrice" title="Unit Price" format="{0:c}" />
//             </Grid>
//         );
//     }

//     return (
//         <div
//             style={{
//                 height: "50px",
//                 width: "100%",
//             }}
//         >
//             <div
//                 style={{
//                     position: "absolute",
//                     width: "100%",
//                 }}
//             >
//                 <div className="k-loading-image" />
//             </div>
//         </div>
//     );
// };
const statusCell = (event) => {
    const val = event.dataItem[event.field]
    const bgcolor = val === 'Active' ? 'rgba(185, 246, 202, 0.376)' : 'rgba(251, 233, 231, 0.5)'; // Change as needed
    const color = val === 'Active' ? 'rgb(0, 200, 83)' : 'rgb(216, 67, 21)'
    return <td > <Chip size='small' style={{ backgroundColor: bgcolor, color: color }} label={val} /></td>
}
function useGrid(props) {
    const { key, columns, gridkey, title, mapActionsToEffects, displayName, navigation, subnavigation, allgriddata, navigateItem, savedreportURL, noRouteIdsReport,
        loadreportfilter, ReportJsonQueryStr, aliases, values, dispatchSharedValueChange, addRoute,
        routeParams, headerProps, customizedheight, subgrid, customsubgrid, nosubgridrouting, ...otherProps } = { ...defaults, ...props };
    const [component, setComponent] = useState(null)
    const [setMinWidth, setSetMinWidth] = useState(false)
    const [gridCurrent, setGridCurrent] = useState(0)
    const [rowSelected, setRowSelected] = useState(null)
    const [hasDefaultReport, setHasDefaultReport] = useState(false)
    const [filteredfield, setFilteredField] = useState([])
    const [initialloadextrainfo, setInitialloadextrainfo] = useState(null)
    const currentField = useRef([])
    const _export = useRef(null)
    const _grid = useRef(null)
    const counter = useRef(0)
    let minGridWidth = 0;
    let grid;
    const sharedProps = props.sharedProps || {}
    const sharedValues = props.sharedValues || []
    const history = useHistory()
    const location = useLocation();
    const params = useParams();
    const parentRecordVals = useSelector(state => state.sidebar && state.sidebar.modules);
    let reduxVals = {}
    if (values['GetParentValues']) {
        /**  GetParentValues:  should be add to jsons to data ( applicant, compnay) get from parent data */
        reduxVals = parentRecordVals

    }

    const [fields, dispatchFieldsChange] = useReducer(
        handleFieldChange,
        {
            gridColumns: columns, total: 0, data: [], exportdata: [], dataState: { skip: 0, take: 20 }, fieldValues: values,
            conditions: mapActionsToEffects, isexport: false, reducerReduxVals: reduxVals,
            pageable: {
                buttonCount: 2,
                info: true,
                type: 'numeric',
                pageSizes: [10, 20, 30, 40, 50, 100],
                previousNext: true
            }
        }
    )

    const prevState = useRef(fields)
    const { gridColumns, data, total, dataState, fieldValues, conditions, pageable, isexport, exportdata, reducerReduxVals } = fields


    useDeepCompareEffect(() => {
        const updatedSharedValues = sharedValues.reduce((accum, each) => {
            accum[each] = fieldValues[each]
            return accum
        }, {})
        const names = Object.keys(updatedSharedValues)
        if (counter.current > 0 && names.length > 0 && dispatchSharedValueChange) {
            dispatchSharedValueChange({
                type: 'values',
                values: names.map(each => {
                    return {
                        name: aliases[each] || each,
                        value: updatedSharedValues[each]
                    }
                })
            })
        }
        counter.current++
    }, [fieldValues])

    useDeepCompareEffect(() => {
        let filterkey = gridkey
        let tempExtras = (localStorage.getItem(filterkey) && JSON.parse(localStorage.getItem(filterkey))) || { skip: 0, take: 20 }
        const prevfieldValues = prevState.current.fieldValues
        const status = isEqual(prevfieldValues, fieldValues)
        if (!status) {
            const unEqualProps = Object.keys(fieldValues).filter(each => fieldValues[each] != prevfieldValues[each])
            unEqualProps.forEach(each => {
                if (conditions[each])
                    handleEffectUpdates(
                        handleActionsToEffects({
                            fieldValues: { ...fieldValues, ...props.match.params, ...reduxVals }, //...prevfieldValues,
                            conditions: conditions[each],
                            extras: tempExtras
                        })
                    )
            })
        }
        prevState.current = fields
    }, [fieldValues])

    useDeepCompareEffect(() => {
        let sharedkeys = Object.keys(sharedProps);
        let filterkey = gridkey
        let tempExtras = (localStorage.getItem(filterkey) && JSON.parse(localStorage.getItem(filterkey))) || { skip: 0, take: 20 }
        if (sharedProps['editOpen'] === undefined)
            setRowSelected(null)
        sharedkeys && sharedkeys.map(share => {
            if (mapActionsToEffects && mapActionsToEffects[share] && (sharedProps[share])) {
                if (addRoute && subgrid && sharedProps['navigation'] && sharedProps['navigation'][routeParams.param]) {
                    let loc = location.pathname
                    let final = loc.substring(0, loc.lastIndexOf("/"))
                    props.history.push(final + '/' + sharedProps['navigation'][routeParams.param])
                }
                handleEffectUpdates(
                    handleActionsToEffects({
                        fieldValues: { ...fieldValues, ...sharedProps, ...props.match.params, ...reduxVals },
                        conditions: mapActionsToEffects[share],
                        extras: tempExtras
                    })
                )
                if (share === 'load' || share === 'loadtemp') {
                    dispatchSharedValueChange({
                        type: 'value',
                        name: share,
                        value: false
                    })
                }
            }
        })
    }, [sharedProps])

    useDeepCompareEffect(() => {
        dispatchFieldsChange({
            type: 'updates',
            updates: {
                value: Object.keys(sharedProps).map(each => {
                    return {
                        key: each,
                        result: sharedProps[each]
                    }
                })
            }
        })
    }, [sharedProps])


    useEffect(() => {
        grid = document.querySelector('.k-grid');
        window.addEventListener('resize', handleResize);
        gridColumns.map(item => minGridWidth += item.width);
        setGridCurrent(grid.offsetWidth)
        setSetMinWidth(grid.offsetWidth < minGridWidth)
        if (props.hascustomcondition) {
            hascustomconditionLoad();
        }
        initialLoad();
    }, [])

    const hascustomconditionLoad = async () => {
        let initialloadextrainfodata = await handlecustomCondition({ ...props, 'options': { 'crud': { customcondition: props.customcondition } } })
        setInitialloadextrainfo(initialloadextrainfodata)
    }

    const initialLoad = async (id, removeString = false) => {
        if (!subgrid) {
            const { match } = props;
            let filterkey = gridkey
            let tempExtras = (localStorage.getItem(filterkey) && JSON.parse(localStorage.getItem(filterkey))) ||
                { skip: 0, take: 20 }
            let url = match.url;
            if (removeString && !noRouteIdsReport) {
                let final = url.substring(0, url.lastIndexOf("/"))
                props.history.push(final)
            }
            if (routeParams && (url.substr(url.lastIndexOf("/") + 1) !== routeParams.replace)) {
                let final = url.substring(0, url.lastIndexOf("/"))
                //props.history.push(final)
            }
            console.log("load")
            if (mapActionsToEffects && mapActionsToEffects['load']) { // dependency and bussiness rules checking
                handleEffectUpdates(
                    handleActionsToEffects({
                        fieldValues: { ...fieldValues, ...props.match.params, ...sharedProps, ...reduxVals },
                        conditions: [],
                        global: (mapActionsToEffects['load']) || [],
                        extras: tempExtras// props.hasreport ? filtereddatastate :
                    })
                )
            }
        }
        if (customsubgrid) {
            console.log("custom")
            if (mapActionsToEffects && mapActionsToEffects['load']) { // dependency and bussiness rules checking
                handleEffectUpdates(
                    handleActionsToEffects({
                        fieldValues: { ...fieldValues, ...props.match.params, ...sharedProps, ...reduxVals },
                        conditions: [],
                        global: (mapActionsToEffects['load']) || [],
                        extras: { skip: 0, take: 20 }
                    })
                )
            }
        }
        if (props.hasreport) {
            let initalReqDataState = { skip: 0, take: 20 }
            let reportinfo = await loadreportdata(props.attachparamgridkey && props.match && props.match.params && props.match.params.key ? props.match.params.key +
                props.gridkey : props.gridkey, id)
            if (reportinfo) {
                let filtereddatastate = reportinfo && reportinfo.columnsdata ? reportinfo.datastate : reportinfo
                let columnsinfo = reportinfo && reportinfo.columnsdata ? reportinfo.columnsdata.flatMap(i => i.field) : null
                let hasfilterfields = reportinfo && reportinfo.columnsdata && filtereddatastate.filter ? columnsinfo.map(field => {
                    if (GridColumnMenuFilter.active(field, filtereddatastate.filter)) {
                        return field;
                    }
                }) : []
                if (filtereddatastate) {
                    dispatchFieldsChange({
                        type: 'updates',
                        updates: {
                            datastate: filtereddatastate
                        }
                    })
                }
                setFilteredField(hasfilterfields);
                // if (DefaultSettings.getAlert() != null && alert)
                //     DefaultSettings.getAlert().show('Please wait Default filter is applying to the grid', 'success');
                if (filtereddatastate && filtereddatastate.toString() !== initalReqDataState.toString()) {
                    console.log("filtereddatastate")
                    if (mapActionsToEffects && mapActionsToEffects['load']) { // dependency and bussiness rules checking
                        handleEffectUpdates(
                            handleActionsToEffects({
                                fieldValues: { ...fieldValues, ...props.match.params, ...sharedProps, ...reduxVals },
                                conditions: [],
                                global: (mapActionsToEffects['load']) || [],
                                extras: filtereddatastate
                            })
                        )
                    }
                }
            }
        }
    }

    const handleResize = () => {
        if (grid.offsetWidth < minGridWidth && !setMinWidth) {
            setSetMinWidth(true)
        } else if (grid.offsetWidth > minGridWidth) {
            setGridCurrent(grid.offsetWidth);
            setSetMinWidth(false)
        }
    }

    const setWidth = (minWidth) => {
        let width = setMinWidth ? minWidth :
            minWidth + (gridCurrent - minGridWidth) / gridColumns.length;
        return width;
    }

    const handleEffectUpdates = (res) => {
        if (res)
            Promise.all(res).then(results => {
                dispatchFieldsChange({
                    type: 'updates',
                    updates: groupByType(results)
                })
            })
    }

    const navigateItems = (newitem) => {
        setRowSelected(newitem)
        rowRender({ props: { children: '' } }, newitem, true)
    }

    const rowRender = (trElement, gridItem, navigate) => {
        const nocolor = { fontWeight: "normal", fontStyle: 'normal' };
        const green = { fontWeight: "bold", fontStyle: 'italic' };
        if (navigate && gridItem && addRoute && !subgrid && !nosubgridrouting) {
            let url = history.location.pathname.substring(0, history.location.pathname.lastIndexOf("/"))
            if (gridItem.dataItem) {
                history.push(url + '/' + gridItem.dataItem[routeParams.param])
            }
            else {
                history.push(url + '/' + gridItem[routeParams.param])
            }
        };
        const trProps = {
            ...trElement.props,
            //style: rowSelected && ((gridItem.dataItem === rowSelected) || (gridItem === rowSelected)) ? green : nocolor,
            onDoubleClick: () => {
                if (mapActionsToEffects && mapActionsToEffects['display']) { // dependency and bussiness rules checking
                    localStorage.setItem('BusinessRules', JSON.stringify([]))
                    counter.current++
                    setRowSelected(gridItem.dataItem)
                    if (addRoute && !subgrid) {
                        history.push(routeParams.replace + '/' + gridItem.dataItem[routeParams.param])
                    }
                    handleEffectUpdates(
                        handleActionsToEffects({
                            //allgriddata stores complete grid data (in that particular page)
                            fieldValues: {
                                ...fieldValues, ...sharedProps, "initialloadextrainfo": initialloadextrainfo && initialloadextrainfo.results ?
                                    initialloadextrainfo.results : null, [displayName]: gridItem.dataItem, [navigation]: gridItem.dataItem,
                                [subnavigation]: gridItem.dataItem, [allgriddata]: data, [navigateItem]: navigateItems, ...props.match.params
                            },
                            conditions: (mapActionsToEffects['display'])
                        })
                    )
                }
            }
        };
        return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
    }

    useDeepCompareEffect(() => {
        if (params && routeParams && params[routeParams.routeName] && !rowSelected && data && data.length > 0)
            if (mapActionsToEffects && mapActionsToEffects['display']) {
                let rowData = data.find(each => each.Id.toString() === params[routeParams.routeName])
                if (!rowData || (rowData && !rowData.Id)) {
                    initialLoad(null, true)
                }
                else {
                    setTimeout(() => {
                        // eslint-disable-next-line no-unused-expressions
                        handleEffectUpdates(
                            handleActionsToEffects({
                                fieldValues: {
                                    ...fieldValues, ...sharedProps, [displayName]: rowData,
                                    [navigation]: rowData, [subnavigation]: rowData,
                                    [allgriddata]: data, [navigateItem]: navigateItems, ...props.match.params, ...reduxVals
                                },
                                conditions: (mapActionsToEffects['display'])
                            })
                        ), 2000
                    })
                }
            }
    }, [params, data])

    const onColumnsSubmit = (columnsState) => {
        dispatchFieldsChange({
            type: 'updates',
            updates: {
                columnProps:
                    { value: columnsState }
            }
        })
    }

    const onClearColumnsSubmit = () => {
        dispatchFieldsChange({
            type: 'updates',
            updates: {
                columnProps:
                    { value: columns }
            }
        })
    }

    const handleDataStateChange = (changeEvent) => {
        let exportdata = changeEvent.dataState && changeEvent.dataState.filter ? true : false;
        if (changeEvent.dataState) {
            let filterkey = gridkey
            localStorage.setItem(filterkey, JSON.stringify(changeEvent.dataState))
        }
        else {
            let filterkey = gridkey
            localStorage.removeItem(filterkey);
        }
        let allcolumns = props && props.columns ? props.columns.flatMap(i => i.field) : null
        let hasfilterfields = [];
        hasfilterfields = exportdata && allcolumns ? allcolumns.map(field => {
            if (GridColumnMenuFilter.active(field, changeEvent.dataState.filter)) {
                return field;
            }
        }) : []
        dispatchFieldsChange({
            type: 'updates',
            updates: {
                datastate: changeEvent.dataState
            }
        })
        if (mapActionsToEffects && mapActionsToEffects['load']) { // dependency and bussiness rules checking
            console.log("datastate")
            handleEffectUpdates(
                handleActionsToEffects({
                    fieldValues: { ...props.match.params, ...sharedProps, ...reduxVals },
                    conditions: [],
                    global: (mapActionsToEffects['load']) || [],
                    extras: changeEvent.dataState
                })
            )
        }
        setFilteredField(hasfilterfields)
    }

    const clearFilters = () => {
        let dataState = {
            skip: 0, take: 20
        }
        if (gridkey)
            localStorage.removeItem(gridkey);
        //this.fetchData(dataState);
        onClearColumnsSubmit();
        dispatchFieldsChange({
            type: 'updates',
            updates: {
                datastate: dataState

            }
        })
        console.log("clear")
        if (mapActionsToEffects && mapActionsToEffects['load']) { // dependency and bussiness rules checking
            handleEffectUpdates(
                handleActionsToEffects({
                    fieldValues: props.match.params, ...sharedProps,
                    conditions: [],
                    global: (mapActionsToEffects['load']) || [],
                    extras: dataState
                })
            )
        }
        setFilteredField([]);
        setHasDefaultReport(false)
    }


    const handleAdd = () => {
        if (mapActionsToEffects && mapActionsToEffects['add']) { // dependency and bussiness rules checking
            // let initialloadextrainforesults = {initialloadextrainfo : initialloadextrainfo && initialloadextrainfo.results ? initialloadextrainfo.results : null}
            counter.current++
            handleEffectUpdates(
                handleActionsToEffects({
                    fieldValues: { ...fieldValues, ...sharedProps, ...props.match.params, initialloadextrainfo, ...reduxVals },
                    conditions: (mapActionsToEffects['add'])
                })
            )
        }

    }
    const handleloadopen = () => {
        if (mapActionsToEffects && mapActionsToEffects['loadprevious']) { // dependency and bussiness rules checking
            // let initialloadextrainforesults = {initialloadextrainfo : initialloadextrainfo && initialloadextrainfo.results ? initialloadextrainfo.results : null}
            counter.current++
            handleEffectUpdates(
                handleActionsToEffects({
                    fieldValues: { ...fieldValues, ...sharedProps, ...props.match.params, initialloadextrainfo, ...reduxVals },
                    conditions: (mapActionsToEffects['loadprevious'])
                })
            )
        }

    }
    const handleswitchopen = () => {
        if (mapActionsToEffects && mapActionsToEffects['switchuser']) { // dependency and bussiness rules checking
            // let initialloadextrainforesults = {initialloadextrainfo : initialloadextrainfo && initialloadextrainfo.results ? initialloadextrainfo.results : null}
            counter.current++
            handleEffectUpdates(
                handleActionsToEffects({
                    fieldValues: { ...fieldValues, ...sharedProps, ...props.match.params, initialloadextrainfo, ...reduxVals },
                    conditions: (mapActionsToEffects['switchuser'])
                })
            )
        }

    }
    const handleReport = () => {
        let datastateval = dataState.value ? dataState.value : dataState
        let gridOptions = getOptions(data, columns, datastateval, savedreportURL);
        if (mapActionsToEffects && mapActionsToEffects['report']) {
            counter.current++
            handleEffectUpdates(
                handleActionsToEffects({
                    fieldValues: {
                        ...fieldValues, ...sharedProps, ...props.match.params, ReportJsonQueryStr: gridOptions,
                        loadreportfilter: initialLoad
                    },
                    conditions: (mapActionsToEffects['report'])
                })
            )
        }
    }

    const handleBack = () => {
        const { match, backnavigation } = props
        let url = match.url
        let final = url
        if (backnavigation) {
            for (let i = 1; i <= backnavigation; i++) {
                final = final.substring(0, final.lastIndexOf("/"))
                props.history.push(final)
            }
        }
        else {
            final = url.substring(0, url.lastIndexOf("/"))
            props.history.push(final)
        }
    }

    const handleDataPageState = () => {
        let deepCopy = _.cloneDeep(dataState);
        const { skip, take, ...otherstate } = deepCopy;
        return { ...otherstate, 'take': total }
    }

    useEffect(() => {
        if (isexport)
            if (_export.current !== null) {
                _export.current.save(exportdata, _grid.current.columns);
            }

        dispatchFieldsChange({
            type: 'updates',
            updates: {
                isexport: true
            }
        })
        dispatchFieldsChange({
            type: 'updates',
            updates: {
                prop: [{
                    type: 'prop',
                    name: 'exportaction',
                    hasValue: true,
                    value: false,
                }]
            }
        })
    }, [isexport])

    const NoDataDisplay = (props, field) => {
        if (props.dataItem[field] == null || props.dataItem[field] === '') {
            return <td style={{ color: '#adabaa' }}> N/A </td>
        }
        return <td > {props.dataItem[field]} </td>

    }

    const CustomDisplay = (event, title) => {
        return <td > <IconButton size='small' color='primary' onClick={() => {
            if (mapActionsToEffects && mapActionsToEffects[title]) { // dependency and bussiness rules checking 
                    // let initialloadextrainforesults = {initialloadextrainfo : initialloadextrainfo && initialloadextrainfo.results ? initialloadextrainfo.results : null}
                    counter.current++
                    handleEffectUpdates(
                        handleActionsToEffects({
                            fieldValues: { ...fieldValues, ...sharedProps, ...props.match.params, initialloadextrainfo, ...reduxVals, ...event.dataItem },
                            conditions: (mapActionsToEffects[title])
                        })
                    ) 
                /*handleEffectUpdates(
                    handleActionsToEffects({
                        fieldValues: { ...params, ...sharedProps, ...props.dataItem },
                        conditions: (mapActionsToEffects[title])
                    })
                )*/
            }
        }}> <Delete fontSize='small'/></IconButton></td>

    }
    const handleCustomCheckBox = (e, props) => {
        // change this code
        let finaldata = this.state.data.map((element) => {
            if (this.props.istransfer && this.props.applicantId && this.props.istransfer == 'Y') {
                if (element.Id == props.dataItem.Id) {
                    return { ...element, hascheckboxselection: !element.hascheckboxselection }
                }
                else {
                    return { ...element, hascheckboxselection: element.hascheckboxselection }
                }
            }
            else {
                if (element.Id == props.dataItem.Id) {
                    return { ...element, hascheckboxselection: true }
                }
                else {
                    return { ...element, hascheckboxselection: false }

                }
            }
        })
        this.setState({ data: finaldata })
        if ((this.props.istransfer || this.props.isrevision) && this.props.applicantId && (this.props.istransfer == 'Y' || this.props.isrevision)) {
            this.props.checkBoxData(finaldata)
        }

        if (this.props.selectedMapData && this.props.customSubmodule)
            this.props.selectedMapData(props.dataItem)
        if (this.props.selectedMapData && this.props.isrevision)
            this.props.selectedMapData(props.dataItem)
    }
    const handleHeaderCheckBox = (e) => {
        const isChecked = e.target.checked;
        const updatedData = data.map((item) => ({ ...item, selected: isChecked }));
         data= updatedData ;
    };

    const handleExport = (actiontype) => {
        if (actiontype === 'filterall' && total > 1000) {
            if (DefaultSettings.getAlert() != null)
                DefaultSettings.getAlert().show('The total results are more than 1000. Please apply a filter to reduce the number of results before exporting.', 'warning');
        }
        else
            if (mapActionsToEffects && mapActionsToEffects['load']) { // dependency and bussiness rules checking
                dispatchFieldsChange({
                    type: 'updates',
                    updates: {
                        prop: [{
                            type: 'prop',
                            name: 'exportaction',
                            hasValue: true,
                            value: true,
                        }]
                    }
                })
                handleEffectUpdates(
                    handleActionsToEffects({
                        fieldValues: { ...props.match.params },
                        conditions: [],
                        global: (mapActionsToEffects['load']) || [],
                        extras: actiontype === 'filterall' ? handleDataPageState() : dataState,
                        kendoProps: true
                    })
                )
            }
    }
    //  let gridDataState = { ...dataState, take: pageable.pageSizes.includes(dataState['take']) ? dataState.take : 'All' }
    // let gridPageable = { ...pageable, ['info']: pageable.pageSizes.includes(dataState['take']) ? true : false }


    const getHeight = () => {
        if (history && history.location.pathname.includes('Records'))
            return window.innerHeight - 240
        else return window.innerHeight - 143
    }
    const checkCondition = (condition) => {
        let tempFields = { ...fieldValues, ...reduxVals }
        if (condition.check && tempFields) {
            let cond1 = handleRules(condition.check, tempFields);
            return cond1
        }
        return true
    }

    return [
        // <div className="col-12">
        <div className=''>
            <div className='col application-border'>
            {headerProps && <GridHeader  {...headerProps} initialloadextrainfo={initialloadextrainfo}
                reportapplied={hasDefaultReport} {...{
                    addOnsByName: {
                        add: { onClick: handleAdd }, excel: { onClick: handleExport }, loadprevious: { onClick: handleloadopen }, switchuser: { onClick: handleswitchopen },
                        clear: { onClick: clearFilters }, back: { onClick: handleBack }, reports: { onClick: handleReport }
                    }
                }}
                sharedProps={{ ...fieldValues, ...reduxVals }} accessPermissions={props.accessPermissions}

            />}</div>
            <ExcelExport
                data={data}
                fileName={title || 'ExcelFile.xlsx'}
                ref={_export}
            >
                 <Grid className='col application-border mb-1' 
                  //  sortable={true}
                    reorderable
                    style={(otherProps && otherProps.style) ? otherProps.style : {
                        height: props.customizedheight ?
                            window.innerHeight - props.customizedheight : getHeight(),
                        width: 'w-90'
                    }}
                    sortable={{
                        //  allowUnsort: allowUnsort,
                          mode:  "multiple"
                        }}
                    resizable
                    data={data}
                    total={total}
                    rowRender={rowRender}
                    pageable={pageable}
                    {...dataState}
                    onDataStateChange={handleDataStateChange}
                    ref={_grid}
                ////  detail={props.detail ? DetailComponent : false}
                //     expandField={"expanded"}
                //   onExpandChange={expandChange}
                >
                    {gridColumns && gridColumns.length > 0 && gridColumns.map((each, index) => {
                        if (each.hideinexternal && getEnvVariable('AccessPortal') == 'E') {
                            return null
                        }
                        else if (each.show && (each.field === 'Custom')) return <GridColumn {...each}
                            filter={each.filter} title={isexport ? each.title : <span className={GridColumnMenuFilter.active(each.field, (dataState && dataState.filter)) ? 'text-primary' : ''}>{each.title}</span>} key={index} width={setWidth(each.width)} cell={e => NoDataDisplay(e, each.field)}
                            columnMenu={
                                props =>
                                    <CustomColumnMenu
                                        {...props}
                                        columns={gridColumns}
                                        onColumnsSubmit={onColumnsSubmit}
                                    />
                            } />
                            else if ((each.field === 'Status' || each.field === 'StatusDesc') && each.show)
                            return <GridColumn {...each} 
                                key={index} width={setWidth(each.width)} cell={e=>statusCell(e,each.field)} title={isexport ? each.title : 
                                <span className={GridColumnMenuFilter.active(each.field, (dataState && dataState.filter)) ? 'text-primary' : ''}>
                                {each.title}</span>}
                                filter={each.filter} columnMenu={
                                    props =>
                                        <CustomColumnMenu
                                            {...props}
                                            columns={gridColumns}
                                            onColumnsSubmit={onColumnsSubmit}
                                        />
                                } />
                        else if (each.show && (each.condition ? checkCondition(each.condition) : true)) return <GridColumn {...each} filter={each.filter} key={index} width={setWidth(each.width)}
                            title={isexport ? each.title : <span className={GridColumnMenuFilter.active(each.field, (dataState && dataState.filter)) ? 'text-primary' : ''}>{each.title}</span>} columnMenu={
                                props =>
                                    <CustomColumnMenu
                                        {...props}
                                        columns={gridColumns}
                                        onColumnsSubmit={onColumnsSubmit}
                                    />
                            } />
                            
                    })}
                </Grid>
            </ExcelExport>
        </div>

    ]
}


export default withRouter(useGrid)

